module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0145.jpg?v=0212ba1a";